import React, { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from '../CheckoutForm';
import Navbar from '../Navbar';
import './styles.css';

import './styles.css';

const stripePromise = loadStripe(
  'pk_live_51QYy4KGLgYouEB3xIa3z7rShQLLNiVM2SHNhztC29Xn2YseqEpDV6or3kNuajs5kDKNAkF717RdIstpCX4BTDX7k00JO9HVCbQ'
);

const Pricing = () => {
  const [clientSecret, setClientSecret] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [hideNav, setHideNav] = useState(false);

  const closePaymentDialog = () => {
    setClientSecret(null);
    setHideNav(false);
  };

  useEffect(() => {
    if (clientSecret) {
      setHideNav(true);
    }
  }, [clientSecret]);

  const handleSelect = async (priceId) => {
    document.querySelectorAll('.button-select').forEach((element) => {
      element.innerHTML = `<div class="flex space-x-2 justify-center items-center ">
                      <div class="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                      <div class="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                      <div class="h-2 w-2 bg-white rounded-full animate-bounce"></div>
                    </div>`;
    });
    try {
      const response = await fetch(
        'https://stripetest-541111223644.us-central1.run.app',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ priceId }),
        }
      );

      const data = await response.json();
      if (data.clientSecret) {
        setSelectedPlan(priceId);
        setClientSecret(data.clientSecret);
      } else {
        console.error('Erro ao criar Payment Intent:', data.error);
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
    }
  };
  let isYearly = true;
  let isToggling = false;

  const toggleToYearly = () => {
    if (isYearly || isToggling) {
      return;
    }
    isYearly = true;
    isToggling = true;
    setTimeout(() => {
      isToggling = false;
    }, 800);
    document
      .querySelector('.div-titles-animation')
      .classList.add('animation-to-right');
    document
      .querySelector('.div-titles-animation')
      .classList.remove('animation-to-left');

    document.querySelector('.monthly-title').classList.remove('active');
    document.querySelector('.yearly-title').classList.add('active');
    document.querySelector('.card-basic').classList.toggle('flip');
    document.querySelector('.card-premium').classList.toggle('flip');
  };

  const toggleToMonthly = () => {
    if (!isYearly || isToggling) {
      return;
    }
    isYearly = true;
    isToggling = true;
    setTimeout(() => {
      isToggling = false;
    }, 800);
    isYearly = false;

    document
      .querySelector('.div-titles-animation')
      .classList.remove('animation-to-right');
    document
      .querySelector('.div-titles-animation')
      .classList.add('animation-to-left');

    document.querySelector('.monthly-title').classList.add('active');
    document.querySelector('.yearly-title').classList.remove('active');
    document.querySelector('.card-basic').classList.toggle('flip');
    document.querySelector('.card-premium').classList.toggle('flip');
  };

  return (
    <>
      <Navbar animation={true} pricingHover={true} hideNav={hideNav} />
      <Elements stripe={stripePromise}>
        <section className="w-dvw min-h-dvh">
          {!clientSecret ? (
            <>
              <div className="pt-32 mb-10 w-dvw flex justify-center align-middle">
                <div className="title-section-pricing absolute flex flex-col text-white w-dvw">
                  <h1 className="text-2xl font-bold md:text-3xl lg:text-4xl xl:text-5xl">
                    Pricing and Features
                  </h1>
                  <h3 className="text-gray-400 text-lg lg:text-xl xl:text-2xl">
                    Start growing for free. Upgrade to unlock more features
                  </h3>
                </div>
                <div className="flex xl:gap-20 lg:gap-16 md:gap-14 gap-14 mt-28 div-titles px-8 py-4 lg:py-5 lg:px-10  relative">
                  <div className="div-titles-animation animation-to-right" />
                  <p
                    onClick={toggleToMonthly}
                    className="xl:text-4xl lg:text-3xl md:text-2xl text-xl title-pricing monthly-title"
                  >
                    Monthly
                  </p>
                  <p
                    onClick={toggleToYearly}
                    className="xl:text-4xl lg:text-3xl md:text-2xl text-xl title-pricing yearly-title active relative"
                  >
                    Yearly
                  </p>
                  <span className="discount-year text-lg lg:text-xl xl:text-2xl">
                    30% OFF!
                  </span>
                </div>
              </div>

              <div className="flex items-center justify-center gap-2 lg:gap-10 mt-16 md:mt-14">
                <div className="card-basic card-pricing">
                  <div className="monthly-card monthly-card-basic">
                    <p className="card-note card-note-basic text-lg lg:text-xl xl:text-2xl">
                      Popular
                    </p>
                    <h2 className="xl:text-5xl md:text-4xl text-2xl">Basic</h2>

                    <p className="description-card xl:text-2xl lg:text-xl md:lg text-base">
                      Several similar applications.
                    </p>
                    <p className="description-card xl:text-2xl lg:text-xl md:lg text-base">
                      Basic customer support.
                    </p>
                    <h3>
                      <span className="euro-symbol xl:text-5xl lg:text-4xl md:text-3xl text-2xl top-1 left-[-15px] lg:left-[-25px] md:left-[-20px] xl:left-[-30px] ">
                        €
                      </span>{' '}
                      <span className="xl:text-6xl lg:text-5xl md:text-4xl text-3xl">
                        1.99
                      </span>{' '}
                      <span className="time-span-month right-[-57px] bottom-[6px] md:right-[-67px] md:text-xl text-base">
                        /month
                      </span>
                    </h3>
                    <button
                      className="button-select text-xl lg:text-2xl h-[45px] lg:h-[55px]"
                      onClick={() => handleSelect('price_id_monthly_basic')}
                    >
                      Select
                    </button>
                  </div>
                  <div className="yearly-card yearly-card-basic">
                    <p className="card-note card-note-basic text-lg lg:text-xl xl:text-2xl">
                      Popular
                    </p>
                    <h2 className="xl:text-5xl md:text-4xl text-2xl">Basic</h2>

                    <p className="description-card xl:text-2xl lg:text-xl md:lg text-base">
                      Several similar applications.
                    </p>
                    <p className="description-card xl:text-2xl lg:text-xl md:lg text-base">
                      Basic customer support.
                    </p>
                    <h3>
                      <span className="euro-symbol xl:text-5xl lg:text-4xl md:text-3xl text-2xl top-1 left-[-15px] lg:left-[-25px] md:left-[-20px] xl:left-[-30px] ">
                        €
                      </span>{' '}
                      <span className="xl:text-6xl lg:text-5xl md:text-4xl text-3xl">
                        12.99
                      </span>{' '}
                      <span className="time-span right-[-40px] bottom-[6px] md:right-[-50px] md:text-xl text-base">
                        /year
                      </span>
                    </h3>
                    <button
                      className="button-select text-xl lg:text-2xl h-[45px] lg:h-[55px]"
                      onClick={() => handleSelect('price_id_yearly_basic')}
                    >
                      Select
                    </button>
                  </div>
                </div>
                <div className="card-premium card-pricing">
                  <div className="monthly-card monthly-card-premium">
                    <p className="card-note card-note-premium top-[-40px] lg:top-[-55px] xl:top-[-60px] text-5xl lg:text-6xl xl:text-7xl">
                      👑
                    </p>
                    <h2 className="xl:text-5xl md:text-4xl text-2xl">
                      Premium
                    </h2>

                    <p className="description-card xl:text-2xl lg:text-xl md:lg text-base">
                      Several similar applications.
                    </p>
                    <p className="description-card xl:text-2xl lg:text-xl md:lg text-base">
                      Priority customer support.
                    </p>
                    <h3>
                      <span className="euro-symbol xl:text-5xl lg:text-4xl md:text-3xl text-2xl top-1 left-[-15px] lg:left-[-25px] md:left-[-20px] xl:left-[-30px] ">
                        €
                      </span>{' '}
                      <span className="xl:text-6xl lg:text-5xl md:text-4xl text-3xl">
                        6.99
                      </span>{' '}
                      <span className="time-span-month right-[-57px] bottom-[6px] md:right-[-67px] md:text-xl text-base">
                        /month
                      </span>
                    </h3>
                    <button
                      className="button-select text-xl lg:text-2xl h-[45px] lg:h-[55px]"
                      onClick={() => handleSelect('price_id_monthly_premium')}
                    >
                      Select
                    </button>
                  </div>
                  <div className="yearly-card yearly-card-premium">
                    <p className="card-note card-note-premium top-[-40px] lg:top-[-55px] xl:top-[-60px] text-5xl lg:text-6xl xl:text-7xl">
                      👑
                    </p>
                    <h2 className="xl:text-5xl md:text-4xl text-2xl">
                      Premium
                    </h2>

                    <p className="description-card xl:text-2xl lg:text-xl md:lg text-base">
                      Several similar applications.
                    </p>
                    <p className="description-card xl:text-2xl lg:text-xl md:lg text-base">
                      {' '}
                      Priority customer support.
                    </p>

                    <h3>
                      <span className="euro-symbol xl:text-5xl lg:text-4xl md:text-3xl text-2xl top-1 left-[-15px] lg:left-[-25px] md:left-[-20px] xl:left-[-30px] ">
                        €
                      </span>{' '}
                      <span className="xl:text-6xl lg:text-5xl md:text-4xl text-3xl">
                        49.99
                      </span>{' '}
                      <span className="time-span right-[-40px] bottom-[6px] md:right-[-50px] md:text-xl text-base">
                        /year
                      </span>
                    </h3>
                    <button
                      className="button-select text-xl lg:text-2xl h-[45px] lg:h-[55px]"
                      onClick={() => handleSelect('price_id_yearly_premium')}
                    >
                      Select
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <CheckoutForm
                clientSecret={clientSecret}
                selectedPlan={selectedPlan}
                closePaymentDialog={closePaymentDialog}
              />
              <div className="blur-lg">
                <div className="pt-32 mb-10 w-dvw flex justify-center align-middle">
                  <div className="title-section-pricing absolute flex flex-col text-white w-dvw">
                    <h1 className="text-5xl font-bold">Pricing and Features</h1>
                    <h3 className="text-2xl text-gray-400">
                      Start growing for free. Upgrade to unlock more features
                    </h3>
                  </div>
                  <div className="flex gap-20 mt-28 div-titles relative">
                    <div className="div-titles-animation animation-to-right" />
                    <p
                      onClick={toggleToMonthly}
                      className="text-4xl title-pricing monthly-title"
                    >
                      Monthly
                    </p>
                    <p
                      onClick={toggleToYearly}
                      className="text-4xl title-pricing yearly-title active"
                    >
                      Yearly
                    </p>
                  </div>
                </div>
                <div className="flex items-center justify-center gap-10">
                  <div className="card-basic card-pricing">
                    <div className="monthly-card monthly-card-basic">
                      <p className="card-note card-note-basic">Popular</p>
                      <h2>Basic</h2>

                      <p className="description-card">
                        Several similar applications.
                      </p>
                      <p className="description-card">
                        Basic customer support.
                      </p>
                      <h3>
                        <span className="euro-symbol xl:text-5xl lg:text-4xl md:text-3xl text-2xl top-1 left-[-15px] lg:left-[-25px] md:left-[-20px] xl:left-[-30px] ">
                          €
                        </span>{' '}
                        1.99 <span>/month</span>
                      </h3>
                      <button
                        onClick={() => handleSelect('price_id_monthly_basic')}
                      >
                        <div N="flex space-x-2 justify-center items-center ">
                          <div N="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                          <div N="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                          <div N="h-2 w-2 bg-white rounded-full animate-bounce"></div>
                        </div>
                      </button>
                    </div>
                    <div className="yearly-card yearly-card-basic">
                      <p className="card-note card-note-basic">Popular</p>
                      <h2>Basic</h2>

                      <p className="description-card">
                        Several similar applications.
                      </p>
                      <p className="description-card">
                        Basic customer support.
                      </p>
                      <h3>
                        <span className="euro-symbol xl:text-5xl lg:text-4xl md:text-3xl text-2xl top-1 left-[-15px] lg:left-[-25px] md:left-[-20px] xl:left-[-30px] ">
                          €
                        </span>{' '}
                        12.99 <span>/year</span>
                      </h3>
                      <button
                        onClick={() => handleSelect('price_id_yearly_basic')}
                      >
                        <div N="flex space-x-2 justify-center items-center ">
                          <div N="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                          <div N="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                          <div N="h-2 w-2 bg-white rounded-full animate-bounce"></div>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div className="card-premium card-pricing">
                    <div className="monthly-card monthly-card-premium">
                      <p className="card-note card-note-premium">👑</p>
                      <h2>Premium</h2>

                      <p className="description-card">
                        Several similar applications.
                      </p>
                      <p className="description-card">
                        Priority customer support.
                      </p>
                      <h3>
                        <span className="euro-symbol xl:text-5xl lg:text-4xl md:text-3xl text-2xl top-1 left-[-15px] lg:left-[-25px] md:left-[-20px] xl:left-[-30px] ">
                          €
                        </span>{' '}
                        6.99 <span>/month</span>
                      </h3>
                      <button
                        onClick={() => handleSelect('price_id_monthly_premium')}
                      >
                        <div N="flex space-x-2 justify-center items-center ">
                          <div N="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                          <div N="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                          <div N="h-2 w-2 bg-white rounded-full animate-bounce"></div>
                        </div>
                      </button>
                    </div>
                    <div className="yearly-card yearly-card-premium">
                      <p className="card-note card-note-premium">👑</p>
                      <h2>Premium</h2>

                      <p className="description-card">
                        Several similar applications.
                      </p>
                      <p className="description-card">
                        {' '}
                        Priority customer support.
                      </p>

                      <h3>
                        <span className="euro-symbol xl:text-5xl lg:text-4xl md:text-3xl text-2xl top-1 left-[-15px] lg:left-[-25px] md:left-[-20px] xl:left-[-30px] ">
                          €
                        </span>{' '}
                        49.99 <span>/year</span>
                      </h3>
                      <button
                        onClick={() => handleSelect('price_id_yearly_premium')}
                      >
                        <div N="flex space-x-2 justify-center items-center ">
                          <div N="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                          <div N="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                          <div N="h-2 w-2 bg-white rounded-full animate-bounce"></div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </section>
      </Elements>
    </>
  );
};

export default Pricing;
